import { takeLatest, put } from '@redux-saga/core/effects';
import Logger from '@noths/logger/build/client';
import Types from '../../types';
import getErrorMessage from '../../utils/getErrorMessage';

import { userHasAccepted, privacyPolicyAccept } from '../../utils/appsync';

export function* checkPrivacyPolicyAcceptance() {
  try {
    const isPolicyAccepted = yield userHasAccepted();
    if (isPolicyAccepted) {
      yield put({ type: Types.SIGN_IN_REDIRECT });
    } else {
      yield put({ type: Types.SHOW_MODAL });
      yield privacyPolicyAccept();
    }
    return true;
  } catch (e) {
    Logger.error(getErrorMessage(e), {
      extra: { description: `Privacy policy acceptance check failed` },
    });
    return false;
  }
}

function* modalSaga() {
  yield takeLatest(Types.MODAL_CHECK, checkPrivacyPolicyAcceptance);
}

export default modalSaga;
